import React from "react";
import {StyledBoxColumn, StyledBoxRow, StyledContainer, StyledEmpty, StyledSpan} from "../../shared/StyledComponents";
import {FormGenContainer} from "../../shared/FormGenContainer";
import {JsonObject} from "../../shared/json/json-object";
import {JsonProperty} from "../../shared/json/json-property";
import {FormGen} from "../../shared/formgen";
import {UserDisplayName} from "../../shared/types";
import {MessageOutlined} from "@mui/icons-material";
import {BaseShowcaseFragment} from "../BaseShowcaseFragment";
import {Button} from "@mui/material";
import {LoginHelper} from "../../shared/LoginHelper";

@JsonObject()
class ContactForm {

  @FormGen({name: "Message", type: "rich_text"})
  @JsonProperty()
  message: string;
}

export class ContactFragment extends BaseShowcaseFragment {

  private readonly contactForm = new ContactForm();

  protected renderPageContent(): React.ReactElement | null {
    const userProfile = this.state.userProfile;
    const contactEnabled = userProfile.metadata?.contactEnabled;
    return <StyledContainer>
      {contactEnabled
        ? <StyledBoxColumn>
          <FormGenContainer content={this.contactForm}/>
          <StyledBoxRow>
            <StyledSpan/>
            <Button
              disabled
              variant="contained"
              onClick={() => LoginHelper.loginAndRun(()=>{})}>Send Message</Button>
          </StyledBoxRow>
        </StyledBoxColumn>
        : <StyledEmpty emptyConfig={{
          title: `${UserDisplayName(userProfile.member.user)} has not enabled messaging.`,
          iconType: MessageOutlined,
        }}/>
      }
    </StyledContainer>
  }
}